{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "Testimonials",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "title",
    "highlight",
    "items"
  ],
  "properties": {
    "title": {
      "title": "Title",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted title part",
      "type": "string",
      "maxLength": 120
    },
    "items": {
      "title": "Reviews",
      "type": "array",
      "maxItems": 30,
      "x-ui": "list",
      "x-itemTitle": "name",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "name",
          "rating",
          "text"
        ],
        "properties": {
          "avatarMediaId": {
            "title": "Avatar",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^[0-9a-fA-F-]{36}$",
            "x-ui": "media"
          },
          "name": {
            "title": "Name",
            "type": "string",
            "maxLength": 100
          },
          "href": {
            "title": "Source link",
            "type": "string",
            "maxLength": 500,
            "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
            "x-ui": "link"
          },
          "rating": {
            "title": "Rating",
            "type": "number",
            "minimum": 0,
            "maximum": 5,
            "multipleOf": 0.5,
            "x-ui": "rating"
          },
          "text": {
            "title": "Text",
            "type": "string",
            "maxLength": 1500,
            "x-ui": "textarea"
          }
        }
      }
    }
  }
}
